/* Light Armor — minimize the Rosie chat launcher (added 2026-08-29).
 *
 * The Rosie app's floating button reads "Chat With Us". Its markup lives inside
 * the <rosie-widget> element's (open) shadow root, where theme CSS can't reach,
 * so this script injects a style sheet into that shadow root and strips the
 * button's text node — leaving a round, icon-only bubble. The aria-label keeps
 * the accessible name, and the notification badge is untouched. A
 * MutationObserver re-strips the text if the app re-renders its button. */
(function () {
  'use strict';
  if (window.__laChatMini) return;
  window.__laChatMini = true;

  var CSS =
    '.minimized-button{' +
    'width:56px !important;min-width:56px !important;max-width:56px !important;' +
    'height:56px !important;padding:6px !important;gap:0 !important;' +
    'border-radius:50% !important;justify-content:center !important;' +
    'font-size:0 !important;line-height:0 !important;box-sizing:border-box !important;}';

  function stripText(root) {
    var btn = root.querySelector('.minimized-button');
    if (!btn) return;
    Array.prototype.forEach.call(btn.childNodes, function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) n.textContent = '';
    });
  }

  function attach(w) {
    var root = w.shadowRoot;
    if (!root || root.__laMini) return;
    root.__laMini = true;
    /* The app re-renders its shadow children, which would sweep away an
       appended <style> element — an adopted stylesheet survives that. */
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    } catch (e) {
      var st = document.createElement('style');
      st.textContent = CSS;
      root.appendChild(st);
    }
    stripText(root);
    new MutationObserver(function () { stripText(root); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  /* The widget renders after its own script loads; poll for up to ~30s. */
  var tries = 0;
  (function poll() {
    var w = document.querySelector('rosie-widget');
    if (w && w.shadowRoot) { attach(w); return; }
    if (++tries < 100) setTimeout(poll, 300);
  }());
}());
